export default {
  'default': {
    appName: 'Turniketová servisná aplikácia :: ANTIK Telecom',
    background: 'bg-12.jpg',
    baseColor: '#6993ff',
  }
};
